import { ItemAttribute } from '../../types/interfaces'
import { unitTypeToShort } from './enumToText'

export const processAttributes = (attributes?: ItemAttribute[]): string => {
  if (!attributes || !Array.isArray(attributes) || attributes.length === 0) {
    return ''
  }

  const filteredAttrs = attributes
    .filter((attr) => attr && attr.isRequired)
    .map((attr) => {
      // INPUT, SELECT или NUMBER
      if (attr.fieldType === 0 || attr.fieldType === 1 || attr.valueType === 1) {
        let val = String(attr.value || '')
        // unit: 0=г, 10=дн и т.д.
        if (attr.unit !== undefined && attr.unit !== -1) {
          val += ` ${unitTypeToShort(attr.unit) || ''}`
        }
        return `${attr.name || ''}: ${val}`
      }
      return null
    })
    .filter(Boolean)

  return filteredAttrs.length > 0 ? ` (${filteredAttrs.join(', ')})` : ''
}
